import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=99707d5c&scoped=true&"
import script from "./Editor.vue?vue&type=script&lang=ts&"
export * from "./Editor.vue?vue&type=script&lang=ts&"
import style0 from "./Editor.vue?vue&type=style&index=0&id=99707d5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99707d5c",
  null
  
)

export default component.exports